import React from "react";
import Slider from "../Slider/Slider";

const RegistrationLeftBar = ({ width }) => <Slider width={width} />;

export default RegistrationLeftBar;
